/**
 * Component for create table with body and header
 *
 * @param {object} props - component props
 * @param {boolean} props.sortable - boolean define if column is sortable
 * @param {Objetc} props.layout - define model view
 * @param {Array} props.records - Array of records to fill in
 * @param {function} props.updateRecords - Function for update records parent
 * @param {function} props.onClickRow - Function for handle event onClickRow
 * @param {function} props.onClickCell - Function for handle event onClickCell
 * @param {boolean} props.paginate - Define if table is paginate
 * @return {Component} - table component
 */
function GridCards({ records, layout, handleView, Card }) {
  // const data = tableData.value;
  // const records = data?.records || [];

  return (
    <div
      id="grid-cards"
      className="md:flex md:flex-wrap tablet:flex tablet:flex-wrap mt-3 justify-start gap-x-2"
    >
      {records.map((rec) => (
        <Card
          key={rec.id}
          layout={layout}
          record={rec}
          onClick={() => handleView("open", rec.id)}
        />
      ))}
    </div>
  );
}

export default GridCards;
